<template>
  <el-select
    v-if="!readonly"
    v-model="selected"
    :multiple="params.multiple"
    :value-key="params.key"
    filterable
    :clearable="params.clearable"
    @remove-tag="removeTag"
    style="width: 100%"
  >
    <el-option
      v-for="(option, optionName, index) in data"
      :key="index"
      :label="option[params.label]"
      :value="option"
      :readonly="true"
    />
  </el-select>
  <el-input
    v-else
    v-model="value"
    :readonly="readonly"
    :class="{ readonly: readonly }"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default() {
        const { multiple } = this.params;
        if (multiple) {
          return [];
        }
        return null;
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Внутри компонента используем объект с названием и id
     * наружу отдаем массив с id
     */
    selected: {
      get() {
        // Массив значений (id / code) → массив объектов-опций
        if (Array.isArray(this.value)) {
          return this.value
            .map((e) => this.data.find((item) => item[this.params.key] === e))
            .filter(Boolean);
        }
        // Одиночное значение → объект-опция
        if (typeof this.value !== "object") {
          return this.data.find((item) => item[this.params.key] === this.value);
        }
        // Уже объект(ы)
        return this.value;
      },
      set(val) {
        if (this.params.fetch) {
          if (this.value.length < val.length) {
            this.addTag(val);
          }
          this.emitFunc(val);
        } else {
          this.emitFunc(val);
        }
      },
    },
  },
  methods: {
    emitFunc(val) {
      this.$emit(
        "input",
        Array.isArray(val)
          ? val
              .map((e) => (e ? e[this.params.key] : null))
              .filter((v) => v !== null && v !== undefined)
          : !val || val[this.params.key] === undefined
          ? null
          : val[this.params.key]
      );
    },
    async addTag() {
      this.$message({
        type: "success",
        message: "Элемент добавлен",
      });
    },
    async removeTag() {
      this.$message({
        type: "success",
        message: "Элемент удален",
      });
    },
  },
};
</script>
